// src/components/album/StepConfigurations.jsx
import React from 'react';
import {
    VStack,
    Box,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    SimpleGrid,
    Text,
    HStack,
    Heading,
    useBreakpointValue,
} from '@chakra-ui/react';
import AlbumFormInput from './AlbumFormInput';

const StepConfigurations = ({
    albumTitle,
    setAlbumTitle,
    dedication,
    setDedication,
    paperSize,
    setPaperSize,
    orientation,
    setOrientation,
    pageLayout,
    setPageLayout,
    coverStyle,
    setCoverStyle
}) => {
    const bgColor = "white";
    const borderColor = "gray.200";

    const RadioOption = ({ value, isSelected, onClick, children }) => (
        <Box
            p={3}
            borderWidth="1px"
            borderRadius="md"
            borderColor={isSelected ? "blue.500" : borderColor}
            bg={isSelected ? "blue.50" : bgColor}
            cursor="pointer"
            onClick={onClick}
        >
            <Radio value={value} width="100%">
                {children}
            </Radio>
        </Box>
    );

    return (
        <VStack spacing={6} align="stretch" w="100%">
            <Heading size="md" color="gray.700">Configurações do Livro</Heading>

            <FormControl>
                <FormLabel fontWeight="medium">Título do livro</FormLabel>
                <AlbumFormInput
                    placeholder="Ex: Minhas Aventuras para Colorir"
                    value={albumTitle}
                    onChange={setAlbumTitle}
                    autoComplete="off"
                />
            </FormControl>

            <FormControl>
                <FormLabel fontWeight="medium">Dedicatória (opcional)</FormLabel>
                <AlbumFormInput
                    isTextarea
                    placeholder="Ex: Para João, com amor..."
                    value={dedication}
                    onChange={setDedication}
                    resize="vertical"
                    rows={3}
                    autoComplete="off"
                />
            </FormControl>

            <FormControl>
                <FormLabel fontWeight="medium">Tamanho do papel</FormLabel>
                <RadioGroup value={paperSize} onChange={setPaperSize}>
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                        <RadioOption 
                            value="A4" 
                            isSelected={paperSize === "A4"}
                            onClick={() => setPaperSize("A4")}
                        >
                            <VStack align="start" spacing={1}>
                                <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                                    A4 (21×29.7cm)
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                    Tamanho padrão de papel
                                </Text>
                            </VStack>
                        </RadioOption>
                        
                        <RadioOption 
                            value="A5" 
                            isSelected={paperSize === "A5"}
                            onClick={() => setPaperSize("A5")}
                        >
                            <VStack align="start" spacing={1}>
                                <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                                    A5 (14.8×21cm)
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                    Metade do A4, tamanho caderno
                                </Text>
                            </VStack>
                        </RadioOption>
                        
                    </SimpleGrid>
                </RadioGroup>
            </FormControl>

            <FormControl>
                <FormLabel fontWeight="medium">Orientação do papel</FormLabel>
                <RadioGroup value={orientation} onChange={setOrientation}>
                    <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
                        <RadioOption 
                            value="portrait" 
                            isSelected={orientation === "portrait"}
                            onClick={() => setOrientation("portrait")}
                        >
                            <HStack align="center" spacing={{ base: 2, md: 3 }}>
                                <Box
                                    width={{ base: "30px", md: "40px" }}
                                    height={{ base: "45px", md: "60px" }}
                                    borderWidth="1px"
                                    borderRadius="sm"
                                    borderColor="gray.300"
                                />
                                <VStack align="start" spacing={0}>
                                    <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                                        Retrato
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                        Vertical
                                    </Text>
                                </VStack>
                            </HStack>
                        </RadioOption>
                        
                        <RadioOption 
                            value="landscape" 
                            isSelected={orientation === "landscape"}
                            onClick={() => setOrientation("landscape")}
                        >
                            <HStack align="center" spacing={{ base: 2, md: 3 }}>
                                <Box
                                    width={{ base: "45px", md: "60px" }}
                                    height={{ base: "30px", md: "40px" }}
                                    borderWidth="1px"
                                    borderRadius="sm"
                                    borderColor="gray.300"
                                />
                                <VStack align="start" spacing={0}>
                                    <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                                        Paisagem
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                        Horizontal
                                    </Text>
                                </VStack>
                            </HStack>
                        </RadioOption>
                    </SimpleGrid>
                </RadioGroup>
            </FormControl>

            <FormControl>
                <FormLabel fontWeight="medium">Estilo da capa</FormLabel>
                <RadioGroup value={coverStyle} onChange={setCoverStyle}>
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
                        {['infantil'].map((style) => (
                            <RadioOption 
                                key={style}
                                value={style} 
                                isSelected={coverStyle === style}
                                onClick={() => setCoverStyle(style)}
                            >
                                <Text fontWeight="medium" textTransform="capitalize" fontSize={{ base: "sm", md: "md" }}>
                                    {style}
                                </Text>
                            </RadioOption>
                        ))}
                    </SimpleGrid>
                </RadioGroup>
            </FormControl>
        </VStack>
    );
};

export default StepConfigurations;